package com.eladfinish.bible.contest.screens.americanQuestions.usecases

import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.data.common.FileStorage
import com.eladfinish.bible.contest.screens.americanQuestions.model.AmericanQuestionItem
import com.eladfinish.bible.contest.screens.pairMatching.usecases.TransformToMultiChoiceQuestionsUseCase

class LoadPairsAsMultiChoiceQuestionsUseCase(
    private val fileStorage: FileStorage,
    private val transformUseCase: TransformToMultiChoiceQuestionsUseCase,
) {
    operator fun invoke(): List<AmericanQuestionItem>? {
        if (!fileStorage.fileExists(folder = Constants.PAIR_MATCHING_FOLDER, name = Constants.PAIR_MATCHING_FILENAME)) {
            return null
        }
        val data = fileStorage.readFile(folder = Constants.PAIR_MATCHING_FOLDER, name = Constants.PAIR_MATCHING_FILENAME)
        return data?.let { transformUseCase(it) }
    }
}
